module.exports = __webpack_public_path__ + "img/product.538f4f0e.png";